import { h } from "@stencil/core";
const render = (designSystem) => (h("ch-test-flexible-layout", { designSystem: designSystem }));
export const flexibleLayoutShowcaseStory = {
    render: render
};
